<div class="row">
    <div class="col-md-6"> 
        <h6 *ngIf="showLang == 'en' "> {{pageheading}} </h6> 
        <h6 *ngIf="showLang == 'ar' "> {{pageheading_ar}} </h6> 
    </div>
    <div class="col-md-6 text-capitalize text-md-right"> <p class="user-txt"> Hala, {{uname}} | <a class="logout" (click)="logout()" >{{ 'HOME.logout' | translate }}</a> </p> </div>
</div>
